import React from "react";
import { useLocation } from "react-router-dom";
import { usePageContext } from "./PageContext";
// Main
import Header from "../home/components/Header";
import About from "../home/components/About";
import AboutProfessional from "../home/components/AboutProfessional";
import Toolkit from "../home/components/Toolkit";
// Game stuff
import ProjectBorderlands from "./components/ProjectBorderlands";
import ProjectPlayStation from "./components/ProjectPlayStation";
import ProjectSMS from "./components/ProjectSMS";
//Web Stuff
import ProjectStreaming from "./components/ProjectStreaming";
import WebProjects from "../home/components/WebProjects";


export default function Home() {
    return (
        <div>
            <Header />
            <About />
            <AboutProfessional />
            <ProjectBorderlands />
            <ProjectPlayStation />
            <ProjectSMS />
            <WebProjects />
            <Toolkit />
        </div>
    );
}
